import AdminLayout from "./AdminLayout";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose } from "redux";
import { firestoreConnect } from "react-redux-firebase";
import SubLoading from '../../Loading/SubLoading';

const AdmissionMain = ({applications}) => {

    let newAplications;

    if (applications) {

        newAplications = applications.filter((application) => {
            return application.applicationStatus === 'pending'
        });    

    }


    return ( 
        <AdminLayout>
            {
                newAplications ? (
                    <div className="row pt-5">
                        <div className="col s12 m10 l10 offfset-m1 offset-l1">
                            <h5 className="title is-size-5-touch has-text-weight-semibold mb-2 grey-text text-darken-3">New Applications</h5>
                            <div className="divider mb-5"></div>
                            <table className="mt-4">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th className="hide-on-small-only">Mode:</th>
                                        <th className="hide-on-small-only">Gender</th>
                                        <th className="hide-on-small-only">ID No.</th>
                                        <th>Course</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody> 
                                {
                                    newAplications.length !== 0 ? (
                                        newAplications.map(application => (
                                            <tr key={application.idNumber}>
                                                <td>{application.title} {application.forenames} {application.surname}</td>
                                                <td className="hide-on-small-only">{application.mode}</td>    
                                                <td className="hide-on-small-only">{application.gender}</td>    
                                                <td className="hide-on-small-only">{application.idNumber}</td>    
                                                <td><Link to={`/admission-admin/${application.id}`}className="button is-success is-small">Review</Link></td>
                                            </tr>     
                                        ))

                                    ) : (
                                        <tr>
                                            <td>No Applications yet...</td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div>

                ) : (
                    <SubLoading />

                )
            }
        </AdminLayout>
     );
}


const mapStateToProps = (state) => {
    //console.log(state);
    return {
        applications: state.firestore.ordered.applications
    };
};
 
export default compose(
    connect(mapStateToProps),
        firestoreConnect((ownProps) => [
            {
                collection: "applications", 
            },
    ])
)(AdmissionMain);